export default async function fetchTodaysScores() {
  try {
    const res = await fetch(
      "https://frrc2gvm6a.execute-api.eu-west-1.amazonaws.com/dev/api/fetchTodaysScores",
      {
        method: "GET"
      }
    ).then((res) => res.json());

    return res;
  } catch (error) {
    return [];
  }
}
